<script>
  import { _ } from "./i18n.js";
  import { f7, Page, Toolbar, Tabs, Tab, Link, Icon } from "framework7-svelte";
  import BottomToolbar from "./Toolbar.svelte";

  export let f7route;
  let admin = f7route.context.admin;
</script>

<Page pageContent={true}>
  <Tabs animated routable>
    <Tab id="New" style="padding-top: 0px" class="page-content" />
    <Tab id="My" style="padding-top: 0px" class="page-content" />
    {#if admin}
      <Tab id="Pending" style="padding-top: 0px" class="page-content" />
      <Tab id="Delivered" style="padding-top: 0px" class="page-content" />
      <Tab id="Users" style="padding-top: 0px" class="page-content" />
    {/if}
  </Tabs>

  <Toolbar top tabbar style="font-size: 0.6rem">
    <Link
      tabLink="#New"
      href="/Order/New"
      routeTabId="New"
      reloadCurrent={true}>
      <Icon style="font-size: 1rem" icon="icon icon-new" />
      <span>{$_('order.newOrder')}</span>
    </Link>
    <Link tabLink="#My" href="/Order/My" routeTabId="My" reloadCurrent={true}>
      <Icon style="font-size: 1rem" icon="icon icon-list" />
      <span>{$_('order.myOrders')}</span>
    </Link>
    {#if admin}
      <Link
        tabLink="#Pending"
        href="/Order/Pending"
        routeTabId="Pending"
        reloadCurrent={true}
        text={$_('order.pending')}>
        <Icon style="font-size: 1rem" icon="icon icon-pending" />
      </Link>
      <Link
        tabLink="#Delivered"
        href="/Order/Delivered"
        routeTabId="Delivered"
        reloadCurrent={true}
        text={$_('order.delivered')}>
        <Icon style="font-size: 1rem" icon="icon icon-deliverable" />
      </Link>
      <Link
        tabLink="#Users"
        href="/Order/Users"
        routeTabId="Users"
        reloadCurrent={true}
        text={$_('order.users')}>
        <Icon style="font-size: 1rem" icon="icon icon-profile" />
      </Link>
    {/if}
  </Toolbar>

  <BottomToolbar tabLinkActive={'/Order/New'} />
</Page>
